import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import clsx from 'clsx';

const CategoryNavigation = () => {
  const { subNavigation } = useTypedSelector(
    (state) => state.productFiltering
  );

  let currentCategory = subNavigation;
  let subCategories = subNavigation.links;
  let foundCategory;

  while (currentCategory.links.length > 0) {
    subCategories = currentCategory.links;
    foundCategory = currentCategory.links.find(
      (l) => l.isSelected == true
    );
    if (!foundCategory || foundCategory.links.length === 0) {
      break;
    } else {
      currentCategory = foundCategory;
    }
  }

  const sortedSubCategories = (subCategories) => {
    const sortedCategories = [...subCategories];
    sortedCategories.sort((a, b) => {
      return a.name.localeCompare(b.name, 'sv', { sensitivity: 'base' });
    });
    return sortedCategories;
  };

  return (
    <div className="hidden flex-col text-md lg:flex">
      <div className="py-3 font-bold lowercase first-letter:capitalize">
        {foundCategory ? (
          <a href={currentCategory.url}>{currentCategory.name}</a>
        ) : (
          currentCategory.name
        )}
      </div>
      <ul className="flex flex-col gap-2 border-b border-solid border-gray-300 pb-4">
        {sortedSubCategories(subCategories).map((link, idx) => (
          <li
            className={clsx(
              foundCategory &&
                foundCategory.url == link.url &&
                'pointer-events-none font-bold',
              'flex'
            )}
            key={link.url + idx}
          >
            <a className="flex flex-1 justify-between" href={link.url}>
              <span className="lowercase first-letter:capitalize">
                {link.name}
              </span>
              {/* <span className="text-sm font-normal text-gray-500">
                ({link.amount})
              </span> */}
            </a>{' '}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoryNavigation;
